import { styled, Heading, css } from "@sourceful/shared-components";
import { Image, SanityProductFeatureSection } from "@sourceful/shared-types";

import ProductFeaturesList from "./ProductFeaturesList";

const FeatureColumns = styled("div", {});

const FeatureItems = styled("li", {
  padding: "0",
  display: "grid",
  mbe: "$block_m3",

  "&:last-child": {
    mbe: "0",
  },

  "@xs": {
    gridTemplateColumns: "1fr",
  },
  "@md": {
    gridTemplateColumns: "1fr 3fr",
  },
  "@lg": {
    gridTemplateColumns: "1fr 3fr",
  },
  "@xl": {
    gridTemplateColumns: "1fr 3fr",
  },
});

const HeadingWrapper = styled("div", {
  "@xs": {
    marginBottom: "20px",
  },
});

const FeatureSectionWrapper = styled("div", {
  maxWidth: "1200px",
  marginTop: "70px",
});

const featureListCss = css({
  margin: "0",
  padding: "0",
});

export interface ListItems {
  featureTitle: string;
  featureDescription: string;
  badge?: "FIXED" | "OPTION";
  image?: Image;
}

export interface ProductFeatureListSectionProps {
  featureSections: SanityProductFeatureSection[];
}

const ProductFeaturesListSection = (props: ProductFeatureListSectionProps) => {
  return (
    <FeatureSectionWrapper>
      <FeatureColumns>
        <ol className={featureListCss()}>
          {props.featureSections.map((section: SanityProductFeatureSection) => {
            return (
              <FeatureItems key={section.id}>
                <HeadingWrapper>
                  <Heading level={3} fontSize={5}>
                    {section.title}
                  </Heading>
                </HeadingWrapper>

                <ProductFeaturesList
                  features={section.features}
                  backgroundTheme={section.backgroundTheme}
                  iconTheme={section.iconTheme}
                />
              </FeatureItems>
            );
          })}
        </ol>
      </FeatureColumns>
    </FeatureSectionWrapper>
  );
};

export default ProductFeaturesListSection;
